import CallAction from '~/components/call/CallAction'
import CurrentServing from '~/components/call/CurrentServing'
import SkipTicket from '~/components/call/SkipTicket'
import TotalServe from '~/components/call/TotalServe'
import VisitorAwaiting from '~/components/call/VisitorAwaiting'
import FloatingUploadRecord from '~/components/common/FloatingUploadRecord'
import DefaultLayout from '~/layouts/DefaultLayout'

const Call = () => {
  return (
    <DefaultLayout>
      <div className="flex h-full w-full gap-4 overflow-hidden">
        <div className="inline-flex w-5/12 flex-col gap-4">
          <CurrentServing />
          <TotalServe />
        </div>
        <div className="w-2/12">
          <CallAction />
        </div>
        <div className="inline-flex w-5/12  flex-col gap-4">
          <VisitorAwaiting />
          <SkipTicket />
        </div>
      </div>
      <FloatingUploadRecord />
    </DefaultLayout>
  )
}

export default Call
